import axios from 'axios';
import React, { useEffect, useState } from 'react'
import Swal from 'sweetalert2';
import { BASE_URL } from 'utils/constants';

const PublishedCapstoneTheme = () => {
    const [capstonethemeBody, setCapstonethemeBody] = useState("");

    useEffect(() => {

        Swal.showLoading();
        axios.get(`${BASE_URL}/capstone/published_capstone_theme/get_published_capstone_theme.php`)
            .then(res => {
                if (res?.data?.data) {
                    const res_data_data = res?.data?.data;
                    // // console.log(res_data_data)
                    if (res_data_data?.hasOwnProperty("capstonetheme")) {
                        if (res_data_data?.capstonetheme?.hasOwnProperty("body")) {
                            setCapstonethemeBody(res_data_data?.capstonetheme?.body)
                        }
                    }
                }
                Swal.close();
            }).catch(err => {
                Swal.fire(err?.response?.data?.msg || "Sorry, try again later", "", "error")

            })

    }, [])

    return (
        <div
            className='mt-3'
            dangerouslySetInnerHTML={{ __html: capstonethemeBody }}
        />
    );

}

export default PublishedCapstoneTheme